import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=43690936&scoped=true&"
import script from "./LegalNotice.vue?vue&type=script&lang=js&"
export * from "./LegalNotice.vue?vue&type=script&lang=js&"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=43690936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43690936",
  null
  
)

export default component.exports